import type { FaireProductEntity } from "../../entity_types/product";

export const p_3tttwsqv5z: FaireProductEntity = {
  token: "p_3tttwsqv5z",
  type: "product",
  name: "POLYSILK DRESS (KT-1517)",
  brandToken: "b_a990dearj1",
  brandName: "Kathmandu Imports",
  imageUrl:
    "https://cdn.faire.com/fastly/ec8416509773cc2821c19fad1b2e8808be11b31710ec7ab4b58916e76c8173b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fe166aa23f49cdf0be7d951247e5200fd91fc71759d5460e8cc957975786ebf2.jpeg",
  ],
  priceDollars: 14,
  description:
    "Mixed Prints Bell Sleeves Tiered Long Dress in Assorted Colors\nFree Size",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:48.370Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
